<template lang="pug">
  #eventActivitySuccess.d-flex.flex-column(
    style="height: calc(100% - 120px)"
  )
    .container-width.text-center.w-100(
      style="flex: 1 1 0;"
    )
      .pt-5(v-if="status === 'SUCCESS'")
        img.p-2(
          :src='okImg',
          alt='success_ok_img',
          width="80",
          style="border-radius: 100%;"
        )
        p.font-weight-bold.mb-0 付款成功
        hr.border-primary.w-100
        //.grayArea.py-5.m-3.text-center(v-if=userInfo)
          h6 {{ userInfo.eventActivity.name }}
          p.pt-2.mb-0 {{ userInfo.selectedDate.activity_start_at }}
          p.pt-2.mb-0 {{ moment(userInfo.selectedDate.activity_start_at + " " + userInfo.selectedTime.activity_start_time).format("HH:mm") }} ~ {{ moment(userInfo.selectedDate.activity_start_at + " " + userInfo.selectedTime.activity_end_time).format("HH:mm") }}
      .pt-5(v-else)
        img.p-2(
          :src='okImg',
          alt='success_ok_img',
          width="60",
          style="border-radius: 100%; background-color: #000"
        )
        p.font-weight-bold.mb-0 付款失敗
        p.font-weight-bold.mb-0 {{ status }}
    .d-flex.justify-content-center.mt-3
      button.btn.btn-block.btn-primary.w-50(
        type="button",
        @click="backToLINEHandler()"
      ) 返回官方帳號
    .d-flex.justify-content-center.mt-3
      button.btn.btn-block.btn-primary.w-50(
        type="button",
        @click="backToEventActivityList()"
      ) 返回預約列表
</template>

<script>
  import okImgUrl from '@/assets/images/icon/icon_black_ok.png';
  import errorImgUrl from '@/assets/images/icon/icon_cross.png';
  import { M_EVENT_ACTIVITY_INDEX } from '@/router/member/event-activity';
  import { mapState } from 'vuex';
  const moment = require('moment');

  export default {
    name: 'eventActivityPaymentStatus',
    props: {
      id: [String, Number]
    },
    data() {
      return {
        okImg: okImgUrl,
        errorImg: errorImgUrl,
        info: null,
        status: null,
      };
    },
    mounted() {
      const vm = this;
      vm.$store.commit('toggleLoading', true);
      vm.$store.dispatch('member_event_activity/getPayResultEventActivityHandler', { id: vm.id }).then((res) => {
        vm.info = res.data.info;
        vm.status = res.data.status;
        vm.$store.commit('toggleLoading', false);
      });
    },
    methods: {
      moment(val) {
        return moment(val);
      },
      backToLINEHandler() {
        window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
      },
      backToEventActivityList() {
        const vm = this;
        vm.$router.push({ name: M_EVENT_ACTIVITY_INDEX });
      }
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.member_event_activity.userInfo
      })
    }
  };
</script>

<style lang="scss" scoped>
  .grayArea {
    background-color: #F0F0F0;
  }
</style>
